import { render, staticRenderFns } from "./PhotoQuestionImage.vue?vue&type=template&id=76993abd&"
import script from "./PhotoQuestionImage.vue?vue&type=script&lang=js&"
export * from "./PhotoQuestionImage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports